import { getAutocompleteUtilityClass, autocompleteClasses as muiAutocompleteClasses } from '@mui/material';

declare module '@mui/material/Autocomplete' {
  interface AutocompletePropsSizeOverrides {
    large: true;
  }
}
export type AutocompleteSizes = 'small' | 'medium' | 'large';

export const autocompleteClasses = {
  ...muiAutocompleteClasses,
  searchFieldSubmit: getAutocompleteUtilityClass('searchFieldSubmit'),
};
